import { defineComponent, computed } from "vue";
import { sortSizes } from "./component-library439.mjs";
import VariantSelector from "./component-library312.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "offer-tile-variant",
  props: {
    variants: { default: void 0 },
    type: null,
    limit: { default: void 0 }
  },
  emits: ["select-variant"],
  setup(__props) {
    const props = __props;
    const mappedVariants = computed(() => {
      if (!props.variants || props.variants.length === 0)
        return [];
      const sortedVariants = props.type === "SIZE" ? sortSizes(props.variants) : props.variants;
      const filteredVariants = sortedVariants.filter((variant) => variant.name !== "");
      if (!props.limit) {
        return filteredVariants;
      }
      const activeVariant = filteredVariants.find((variant) => variant.active);
      const otherVariants = filteredVariants.filter((variant) => !variant.active).slice(0, props.limit);
      return activeVariant ? [activeVariant, ...otherVariants] : otherVariants;
    });
    return { __sfc: true, props, mappedVariants, VariantSelector };
  }
});
export {
  _sfc_main as default
};
